"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withLiveInterviewStatuses = exports.withLearnedInterviewStatus = exports.getOpenInterviewStatus = void 0;
const reviewDecisionStatusHelper_1 = require("./reviewDecisionStatusHelper");
/**
 * Reads from the review panel state the review status and completion of the interview open in it.
 * @param interview - Interview open in the review panel, absent when the list stands alone
 * @param reviewDecisionStatusByObject - Review status of that interview, undefined while loading
 * @returns Values the review panel shows, or undefined when nothing reliable can be read yet
 */
const getOpenInterviewStatus = (interview, reviewDecisionStatusByObject) => {
    var _a;
    if (!interview || reviewDecisionStatusByObject === undefined) {
        return undefined;
    }
    // Opening an interview resets the decisions, so a loaded map always describes this one: an
    // interview missing from it has no decision left, rather than decisions not known yet.
    const status = (0, reviewDecisionStatusHelper_1.getReviewDecisionStatusForObject)(reviewDecisionStatusByObject, 'interview', interview.uuid);
    return {
        uuid: interview.uuid,
        review_status: (_a = status === null || status === void 0 ? void 0 : status.effectiveStatus) !== null && _a !== void 0 ? _a : 'notReviewed',
        is_completed: interview.is_completed
    };
};
exports.getOpenInterviewStatus = getOpenInterviewStatus;
/**
 * Adds a status to those learned from the review panel, returning the same object when it brings
 * nothing new, so that a component holding them in state does not render again for nothing.
 * @param liveStatusByUuid - Statuses learned so far
 * @param status - Status read from the review panel, if any
 * @returns The statuses, with that of the interview updated
 */
const withLearnedInterviewStatus = (liveStatusByUuid, status) => {
    if (status === undefined) {
        return liveStatusByUuid;
    }
    const known = liveStatusByUuid[status.uuid];
    return (known === null || known === void 0 ? void 0 : known.review_status) === status.review_status && (known === null || known === void 0 ? void 0 : known.is_completed) === status.is_completed
        ? liveStatusByUuid
        : Object.assign(Object.assign({}, liveStatusByUuid), { [status.uuid]: status });
};
exports.withLearnedInterviewStatus = withLearnedInterviewStatus;
/**
 * Refreshes the interview list rows with the decisions taken in the review panel beside it.
 * The list holds a server snapshot from its last fetch, so its rows would otherwise keep showing
 * the review status and the completion the interviews had back then. Only the decisions of the
 * reviewer working beside the list are followed; those of the others show on the next fetch.
 * @param interviews - Rows of the interview list, as last fetched
 * @param liveStatusByUuid - Statuses learned since, from {@link withLearnedInterviewStatus}
 * @returns The rows, those of the reviewed interviews carrying the values of the review panel
 */
const withLiveInterviewStatuses = (interviews, liveStatusByUuid) => Object.keys(liveStatusByUuid).length === 0
    ? interviews
    : interviews.map((interview) => {
        const liveStatus = liveStatusByUuid[interview.uuid];
        return liveStatus === undefined
            ? interview
            : Object.assign(Object.assign({}, interview), { review_status: liveStatus.review_status, is_completed: liveStatus.is_completed });
    });
exports.withLiveInterviewStatuses = withLiveInterviewStatuses;
//# sourceMappingURL=interviewListLiveStatus.js.map